import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import secureLocalStorage from '../../utils/secureStorage';
import { useAuth } from '../../hooks/AuthProvider';

const InActiveLogoutTimer = () => {
  const location = useLocation();
  const { authenticated, logout } = useAuth();

  const updateExpiryTime = () => {
    if (authenticated) {
      const expireTime = Date.now() + 1 * 60 * 60 * 1000; // one hour in milliseconds
      secureLocalStorage.setItem('swob-inActive-expireTime', expireTime.toString());
    }
  };

  useEffect(() => {
    const checkForInactivity = () => {
      const expireTimeString = secureLocalStorage.getItem('swob-inActive-expireTime');
      const expireTime = expireTimeString ? parseInt(expireTimeString as string) : 0;

      if (expireTime < Date.now() && location.pathname !== '/login') {
        logout();
      }
    };

    const interval = setInterval(
      () => {
        checkForInactivity();
      },
      15 * 60 * 1000
    ); // Check for inactivity every 15 mins

    return () => clearInterval(interval);
  }, [location, logout]);

  useEffect(() => {
    const events = ['click', 'keypress', 'scroll', 'mousemove'];

    const update = () => {
      updateExpiryTime();
    };

    events.forEach((event) => window.addEventListener(event, update));

    return () => {
      events.forEach((event) => window.removeEventListener(event, update));
    };
  }, []);

  return null;
};

export default InActiveLogoutTimer;
